import React from 'react';
import { css } from '@emotion/react';
import { QUERY_REQUEST, MUTATION_UPDATE_DATA_START } from 'queries/queries-booking';

import { useMutation, useQuery } from 'urql';
import { Button } from '../../../components/Button';

import { useStep } from '../hooks/useStep';

import { theme } from 'styles/theme';
import { SpinnerBlock } from 'components/SpinnerBlock';
import { CopyToClipboard } from 'screens/booker/screens/request/components/CopyToClipboard';
import { useRequestStateQuery } from 'generated/graphql';

export const StartStep = () => {
	const { id, goNextStep } = useStep();

	// Get information about event
	const [requestResult] = useQuery({
		query: QUERY_REQUEST,
		variables: {
			url: id,
		},
	});

	const [_stateRequest] = useRequestStateQuery({
		variables: { url: id },
	});

	const { data, fetching, error } = requestResult;
	const request = data?.request;

	// Submit Form
	const [updateDataStart, executeUpdateDataStart] = useMutation(MUTATION_UPDATE_DATA_START);

	const onSubmit = () => {
		executeUpdateDataStart({
			url: id,
		}).then((result) => {
			// console.log(result);

			if (result?.error) {
				// VYHODIT ERROR
				return false;
			}

			goNextStep();
		});
	};

	return (
		<div
			css={css`
				width: 440px;
				padding-top: 64px;
				padding-bottom: 64px;
				justify-content: center;
				align-items: center;
				display: flex;
				flex-direction: column;
			`}
		>
			{!fetching ? (
				<>
					<div
						css={css`
							font-size: 32px;
							color: ${theme.color.text['400']};
							text-align: center;
							line-height: 40px;
							margin-bottom: 12px;
						`}
					>
						Booking
					</div>
					<div
						css={css`
							font-size: 16px;
							color: ${theme.color.text['300']};
							text-align: center;
							line-height: 24px;
							margin-bottom: 32px;
						`}
					>
						<strong>Pro dokončení bookingu vyplňte veškeré údaje a poptávku odešlete.</strong>
						<br />
						Některé údaje je možné doplnit nejpozději týden před konáním akce.
					</div>

					<div
						css={css`
							text-align: center;
							display: flex;
							flex-direction: column;
							gap: 20px;
							margin-bottom: 32px;
							color: ${theme.color.text['300']};

							&:hover {
								cursor: pointer;
							}
						`}
					>
						<strong>Tento odkaz si uložte. Kdykoliv se můžete k vyplňování vrátit.</strong>
						<div>
							<CopyToClipboard isInfoBlock value={process.env.BASE_URL + 'booking/' + id}>
								{process.env.BASE_URL}booking/{id}
							</CopyToClipboard>
						</div>
					</div>

					<Button block large onClick={onSubmit} isProcessing={updateDataStart.fetching}>
						Pokračovat
					</Button>
				</>
			) : (
				<SpinnerBlock />
			)}
		</div>
	);
};
